import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const REVIEWS = `${PRIVATE_ROOT}/community/reviews`
export const ADD_REVIEW = `${PRIVATE_ROOT}/community/reviews/add`
export const EDIT_REVIEW = `${PRIVATE_ROOT}/community/review/:id/edit`
export const REPLY_TO_REVIEW = `${PRIVATE_ROOT}/community/review/:id/reply`
